import React from "react";
import { FaUser } from "react-icons/fa";

import { IconTag } from "./IconTag";

interface IIconTagUser {
  name: string;
}

/**
 * An IconTag wrapper to display a user as a tag.
 * @param {string} name Name of the user being displayed.
 */
function IconTagUser({ name, ...delegated }: IIconTagUser) {
  return <IconTag icon={FaUser} text={name} {...delegated} />;
}

export { IconTagUser };
